<script lang="ts" setup>
import CategoriesField from '@/components/categories/CategoriesField.vue';
import StepsField from '@/components/action/StepsField.vue';
import { Action } from '@/models/action.model';
import { ref, PropType, watch, onMounted, computed } from 'vue';
import RichTextField from '@/components/common/RichTextField.vue';
import MediaList from '@/components/media/MediaList.vue';
import { MediaPurpose } from '@/models/media.model';
import { useStore } from 'vuex';
import { LabelsActions, LabelsState } from '@/stores/labels.store';
import { UserLabel } from '@/models/label.model';
import { ShiftCMSState } from '@/store';
import CategoryField from '../categories/CategoryField.vue';

const store = useStore<ShiftCMSState & { ls: LabelsState }>();

const labels = computed<UserLabel[]>(() => store.state.ls.labels);

const props = defineProps({
  modelValue: { type: Object as PropType<Action>, required: true },
});
const value = ref<Action>({ ...(props.modelValue || []) });

const emit = defineEmits(['update:modelValue', 'update:published']);

const update = () => {
  emit('update:modelValue', value.value);
};
watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);

// const types = [
//   {
//     title: 'Action',
//     value: ActionType.Action,
//   },
//   {
//     title: 'Tips',
//     value: ActionType.Tips,
//   },
// ];

const togglePublished = async (published: boolean) => {
  if (value.value.id !== -1) {
    emit('update:published', { ...value.value, published: !published });
  }
  value.value.published = !published;
};

onMounted(() => {
  store.dispatch(LabelsActions.GetLabels);
});
</script>
<template>
  <v-row>
    <v-col>
      <v-row class="mb-2">
        <v-col cols="9">
          <v-text-field
            v-model="value.title"
            @change="update"
            label="Title"
            required
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="pt-6">
          <v-btn
            block
            @click="() => togglePublished(value.published)"
            :color="!value.published ? 'success' : 'warning'"
            >{{ value.published ? 'Un-publish' : 'Publish' }}</v-btn
          >
        </v-col>
      </v-row>

      <!-- <v-select
        v-model="value.type"
        :items="types"
        @update:model-value="update"
        label="Type"
        required
      ></v-select> -->

      <CategoryField
        main
        v-model="value.mainCategory"
        @change="update"
        disabled
        label="Main Category"
      />

      <CategoriesField v-model="value.categories" @change="update" />

      <v-select
        v-model="value.notRelevantForlabels"
        label="Not relevant for labels"
        multiple
        clearable
        class="mb-4"
        hide-details="auto"
        :style="{ background: 'white' }"
        :items="labels.map((q) => ({ title: q.value, value: q }))"
        ><template v-slot:item="{ props }">
          <v-list-item v-bind="props">
            <v-list-item-title></v-list-item-title>
          </v-list-item> </template
      ></v-select>

      <v-slider
        label="Difficulty"
        v-model="value.difficulty"
        @end="update"
        :min="0"
        :step="1"
        :max="100"
      >
        <template v-slot:append>
          <div class="slider-number">{{ value.difficulty }}</div>
        </template></v-slider
      >
      <v-slider
        label="Impact"
        v-model="value.impact"
        @end="update"
        :min="0"
        :step="1"
        :max="100"
      >
        <template v-slot:append>
          <div class="slider-number">{{ value.impact }}</div>
        </template></v-slider
      >

      <RichTextField
        label="Short description"
        :height="200"
        v-model="value.shortDescription"
        hint="Used in stories when users choose their interest"
        @change="update"
        :media="modelValue.media"
      />

      <RichTextField
        label="Description"
        v-model="value.description"
        hint="Used as the full text of the action"
        @change="update"
        :media="modelValue.media"
      />
      <StepsField v-model="value.steps" @change="update" :action="value" />

      <MediaList
        v-model="value"
        @change="update"
        :required="[MediaPurpose.BackgroundImage, MediaPurpose.Main]"
      />
    </v-col>
  </v-row>
</template>
<style scoped>
.slider-number {
  width: 40px;
  text-align: center;
}
</style>
